import type { ProLayoutProps } from '@ant-design/pro-components';

/**
 * @name
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  // 默认配置，实际样式在 layout 中动态设置
  navTheme: 'light',
  colorPrimary: '#1890ff',
  layout: 'top',
  contentWidth: 'Fluid',
  fixedHeader: true,
  fixSiderbar: true,
  pwa: true,
  logo: '/logo.svg',
  title: 'Ant Design Pro',
  token: {},
  splitMenus: false,
  footerRender: false,

  // Ant Design Pro 官方推荐样式组合：
  // 1. 经典侧边栏: layout: 'side', navTheme: 'light'
  // 2. 现代顶部导航: layout: 'top', navTheme: 'light'
  // 3. 高级混合布局: layout: 'mix', navTheme: 'light'
  // 4. 深色护眼模式: layout: 'side', navTheme: 'dark'
  // 5. 深色顶部导航: layout: 'top', navTheme: 'dark'
};

export default Settings;
